import "./App.css";
import React from "react";
import { Suspense, lazy } from "react"

import { Route, Routes } from "react-router-dom";
import { MsalProvider } from "@azure/msal-react";
import { RouteGuard } from "./components/RouteGuard";
import Dashboard from "./components/DashBoard";
import Engineer from "./components/Engineer";
import Customer from "./components/Customer/Customer";
import { appRoles } from "./authConfig";
// require('dotenv').config()



const App = ({ instance }) => {

  return (

    <MsalProvider instance={instance}>
      <Routes>
        <Route
          path="/engineer"
          element={
            <RouteGuard roles={[appRoles.Engineer]}>
              <Dashboard />
            </RouteGuard>
          }
        />
        <Route
          path="/engineer/:id"
          element={
            <RouteGuard roles={[appRoles.Engineer]}>
              <Engineer />
            </RouteGuard>
          }
        />

        <Route
          path="/customer/:id"
          element={
            <RouteGuard roles={[appRoles.Engineer, appRoles.Customer]}>
              <Customer />
            </RouteGuard>
          }
        />
      </Routes>
    </MsalProvider>

  );
};

export default App;

